<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { disable_user_profile_update } =
      currentAccount.value?.settings || {};
    isEnabled.value = !!disable_user_profile_update;
  },
  { deep: true, immediate: true }
);

const toggleSetting = async () => {
  try {
    await updateAccount({
      disable_user_profile_update: isEnabled.value,
    });
    useAlert(
      t('GENERAL_SETTINGS.FORM.DISABLE_USER_PROFILE_UPDATE.API.SUCCESS')
    );
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.DISABLE_USER_PROFILE_UPDATE.API.ERROR'));
    isEnabled.value = !isEnabled.value;
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.DISABLE_USER_PROFILE_UPDATE.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.DISABLE_USER_PROFILE_UPDATE.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleSetting" />
      </div>
    </template>
  </SectionLayout>
</template>
